












import {Vue, Component, Prop} from 'vue-property-decorator';
import BackHomeButton from '@/components/BackHomeButton.vue';
import {ProjectInfoInterface} from '@/interfaces/ProjectInfo';

@Component({
    name: 'ProjectHeader',
    components: {BackHomeButton},
})
export default class ProjectHeader extends Vue {
    @Prop({required: true}) public projectInfo!: ProjectInfoInterface;
}
